import { layout } from 'thewest/App.routing'
import { createPageDefinition, RouteServices } from 'common/routing/page-definition'
import { metrics } from 'component-library/__styling/settings'
import { isFeatureEnabled } from 'common/feature-togglings/features'
import { RouteResolution } from 'common/routing/route-resolver'
import { staticContentRoutes } from '../static/static-content-routes'
import { TheWestSection } from 'component-library/__styling/settings/sections/thewest'

export type RegionalContactPageOptions = {
    section: TheWestSection
    mastheadName: string
}
export const getRegionalContactUsPage = (
    services: RouteServices<RouteResolution>,
    options: RegionalContactPageOptions
) => {
    if (!isFeatureEnabled(services.store.getState().toggles, 'regionals')) {
        // DPT-1409: if the section is countryman, we need to return the exsting page for it
        if (options.section === 'countryman') {
            return staticContentRoutes['/contact/countryman'](services)
        }

        return null
    }

    const adTargeting = services.getAdTargeting(
        'home',
        options.section,
        `${options.section}-contact`
    )

    return createPageDefinition(
        {
            heading: 'Contact Us',
            hideHeading: true,
            pageType: 'static',
            pageMeta: {
                title: 'Contact Us',
                description: `Contact Us | ${options.mastheadName}`,
            },
            noMetaTitleTemplate: true,
            adTargeting,
            section: options.section,
        },
        layout.composition({
            type: 'box',
            props: {
                containerWidth: metrics.thewest.mainContentWidth,
                verticalGutters: ['outerMargin', 'unset'],
                horizontalGutters: 'outerMargin',
            },
            contentAreas: {
                main: [
                    layout.component({
                        type: 'breadcrumb',
                        props: {
                            title: 'Contact Us',
                        },
                    }),
                ],
            },
        }),
        layout.composition({
            type: 'thor',
            props: {
                containerWidth: metrics.thewest.mainContentWidth,
            },
            contentAreas: {
                main: [
                    layout.nestedComposition({
                        type: 'thor',
                        props: {
                            containerWidth: '100%',
                            horizontalGutters: true,
                            hasBackgroundFill: true,
                        },
                        contentAreas: {
                            main: [
                                layout.component({
                                    type: 'static-content',
                                    props: {
                                        dataDefinitionArgs: {
                                            id:
                                                options.section === 'countryman'
                                                    ? `contact-countryman`
                                                    : `${options.section}-contact`,
                                        },
                                    },
                                }),
                            ],
                        },
                    }),
                ],
            },
        })
    )
}
